module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/cover"
    }
  }, [_vm._v("HUNTER’S GREEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DREAM OF ORCHIDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/fm_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WINTER PEOPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Phyllis A. Whitney")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 75
// module chunks = 0